const deepFilter = (obj, filter) => {
  //iterate the object
  for (let key in obj) {
    const val = obj[key];

    //if val is also object (nested)
    if (typeof val === "object") {
      //recur
      deepFilter(val, filter);
    }
    // normal value
    else {
      //current val fails filter condition
      //delete it
      if (filter(val) === false) {
        delete obj[key];
      }
    }

    //if value is empty obj
    //delete it
    if (JSON.stringify(val) === "{}") {
      delete obj[key];
    }
  }

  return obj;
};

export default deepFilter;
